@let icon = iconName();
<div class="board-column__header df df-c jc-c" [ngClass]="COLORS_MAP[color()]">
  <div class="board-column__header-title df ai-c">
    @if (icon) {
      <fr8bot-ui-icon [name]="icon" [size]="16" />
    }
    <span class="board-column__header-title-text typography-headline-3">{{
      titleText() | translate
    }}</span>
  </div>

  <span class="board-column__header-subtitle typography-small-text">
    {{ subtitleText() | translate }}
  </span>

  <span class="board-column__header-count typography-headline-3">
    {{ itemsCount() }}
  </span>
</div>

<div
  uiInfiniteScroll
  [uiInfiniteScrollDisabled]="loadMoreDisabled()"
  class="board-column__content"
  (scrolledToEnd)="scrolledToBottom.emit()"
>
  <fr8bot-ui-content-border-shadow [sides]="['top']" />

  <div class="board-column__content-inner">
    <ng-content></ng-content>
  </div>
</div>
